var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.76,8.64v3.88A8.16,8.16,0,0,0,12,20.29V5.73Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20.29l.66-.19a8.16,8.16,0,0,0,5.58-7.58V8.64L12,5.73Z",
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.79,4.14a2.85,2.85,0,0,0-.29,0l.83-1-.57-.48-1.67,2,2,1.66.48-.57-1-.85a2.3,2.3,0,0,1,.26,0,2.64,2.64,0,0,1,2.64,2.64,2.58,2.58,0,0,1-.29,1.19l.55.56.09-.13a3.5,3.5,0,0,0,.4-1.62A3.39,3.39,0,0,0,17.79,4.14Z",
    style: {
      fill: "#aecbfa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67,17.7l-.61.44.76,1.06a2.48,2.48,0,0,1-.27,0,2.64,2.64,0,0,1-1.33-4.29l-.39-.68a1.14,1.14,0,0,0-.11.11,3.38,3.38,0,0,0,1.65,5.58,2.93,2.93,0,0,0,.29.05l-1,.74.44.61,2.11-1.5Z",
    style: {
      fill: "#4285f4"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.437eadd47f8dec7178179fd19e8cad0e.svg";
export { ForwardRef as ReactComponent };